export const ElianaEvents = {};

ElianaEvents.hasActiveEvent = () => {
  return ElianaEvents.openPortalToHell() || 
    ElianaEvents.firstTimeThroughPortal();
}

ElianaEvents.displayHint = () => {
  return ElianaEvents.openPortalToHell() || 
  ElianaEvents.firstTimeThroughPortal();
}

ElianaEvents.openPortalToHell = () => {
  // czy odbył się event z Meg
  if(!EventStateService.megNightVisit) {
    return false;
  }

  return !EventStateService.elianaOpenPortalToHell;
}

ElianaEvents.firstTimeThroughPortal = () => {
  // czy odbył się event wizytą w biurze Inspektora
  if(!EventStateService.elianaOpenPortalToHell) {
    return false;
  }

  return !EventStateService.elianaFirstTimeThroughPortal;
}
